// import Botao from "componentes/Botao";
import style from "./Card.module.scss";
import ReactCardFlip from 'react-card-flip';
import { useState } from "react";
import { v4 as uuidv4 } from "uuid";

import FrontCard from "./FrontCard";
import BackCard from "./BackCard";


const Card = () => {
  const animais = [
    {
      id: uuidv4(),
      nome: 'Bento',
      raca: 'Poodle',
      imagem: '/imagens/cao1.jpg',
      informacoes: {
        idade: 5,
        bairro: 'Umuruama',
        desaparecido: '15/09/2020',
        detalhes: 'Corte na pata',
        contato: '(34) 00000-0000',
        recompensa: true
      },

    },
    {
      id: uuidv4(),
      nome: 'Melissa',
      raca: 'Vira-lata',
      imagem: '/imagens/cao2.jpg',
      informacoes: {
        idade: 5,
        bairro: 'Pontal',
        desaparecido: '15/02/2023',
        detalhes: 'Rabo cortado',
        contato: '(34) 00000-0000 /00000 - 0000',
        recompensa: true
      },

    },
    {
      id: uuidv4(),
      nome: 'Juno',
      raca: 'Bulldog',
      imagem: '/imagens/cao3.jpg',
      informacoes: {
        idade: 5,
        bairro: 'Olinda',
        desaparecido: '01/10/2022',
        detalhes: 'Mancha na barriga',
        contato: '(34) 00000-0000 /00000 - 0000',
        recompensa: true
      }

    },
    {
      id: uuidv4(),
      nome: 'Cristal',
      raca: 'Vira-lata',
      imagem: '/imagens/cao4.jpg',
      informacoes: {
        idade: 5,
        bairro: 'Morumbi',
        desaparecido: '01/05/2022',
        detalhes: 'Toma remédio diário para hipoteiroidismo, tem uma cicatriz na orelha esquerda',
        contato: '(34) 00000-0000 /00000 - 0000',
        recompensa: true
      }

    },
    {
      id: uuidv4(),
      nome: 'Marley',
      raca: 'Bulldog',
      imagem: '/imagens/cao5.jpg',
      informacoes: {
        idade: 5,
        bairro: 'Beija-flor',
        desaparecido: '01/05/2021',
        detalhes: 'Toma remédio diário para alergia',
        contato: '(34) 00000-0000 /00000 - 0000',
        recompensa: true
      }

    },
    {
      id: uuidv4(),
      nome: 'Marley',
      raca: 'Bulldog',
      imagem: '/imagens/cao5.jpg',
      informacoes: {
        idade: 5,
        bairro: 'Beija-flor',
        desaparecido: '01/05/2021',
        detalhes: 'Toma remédio diário para alergia',
        contato: '(34) 00000-0000 /00000 - 0000',
        recompensa: true
      }

    },
    {
      id: uuidv4(),
      nome: 'Marley',
      raca: 'Bulldog',
      imagem: '/imagens/cao5.jpg',
      informacoes: {
        idade: 5,
        bairro: 'Beija-flor',
        desaparecido: '01/05/2021',
        detalhes: 'Toma remédio diário para alergia',
        contato: '(34) 00000-0000 /00000 - 0000',
        recompensa: true
      }

    },
    {
      id: uuidv4(),
      nome: 'Marley',
      raca: 'Bulldog',
      imagem: '/imagens/cao5.jpg',
      informacoes: {
        idade: 5,
        bairro: 'Beija-flor',
        desaparecido: '01/05/2021',
        detalhes: 'Toma remédio diário para alergia',
        contato: '(34) 00000-0000 /00000 - 0000',
        recompensa: true
      }

    },
    {
      id: uuidv4(),
      nome: 'Marley',
      raca: 'Bulldog',
      imagem: '/imagens/cao5.jpg',
      informacoes: {
        idade: 5,
        bairro: 'Beija-flor',
        desaparecido: '01/05/2021',
        detalhes: 'Toma remédio diário para alergia',
        contato: '(34) 00000-0000 /00000 - 0000',
        recompensa: true
      }

    }
    
  ]

  const [listaAnimais, setListaAnimais] = useState(animais);


  function handleClick(indice) {
    const listaAtualizada = [...listaAnimais]
    listaAtualizada[indice].isFlipped = !listaAtualizada[indice].isFlipped
    setListaAnimais(listaAtualizada)
  }

  return (
    <div>

      <ul className={style.container}>
        {listaAnimais.map((animal, indice) => {
          return (
            <li className={style.lista} key={animal.id}>
              <ReactCardFlip containerStyle={{ width: '200px', height: '100%' }} isFlipped={animal.isFlipped || false} flipDirection="horizontal">
                <FrontCard
                  foto={animal.imagem}
                  nome={animal.nome}
                  raca={animal.raca}
                  clique={() => handleClick(indice)}
                />
                <BackCard
                  nome={animal.nome}
                  idade={animal.informacoes.idade}
                  bairro={animal.informacoes.bairro}
                  dataDesaparecimento={animal.informacoes.desaparecido}
                  detalhes={animal.informacoes.detalhes}
                  contato={animal.informacoes.contato}
                  clique={() => handleClick(indice)}
                />
              </ReactCardFlip>

            </li>
          )
        })}
      </ul>
    </div>
  )

}

export default Card;